import { EventEmitter, Output } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationState, WorkflowData } from '../../../../../applications/models/applications.models';
import { DomainDefinitionService } from '../../../../../builder/services/domain-definition.service';
import { Well } from '../../../../../common/models/well.model';
import { FormationModel } from '../../../../../form-controls/components/new-casing-plan/models/casing-plan.model';
import { AuthService } from '../../../../../services/auth.service';

@Component({
    selector: 'app-formations',
    templateUrl: './formations.component.html',
    styleUrls: ['./formations.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class FormationsComponent extends ApplicationSectionBaseComponent implements OnInit {
	@Input() form: FormGroup;
	@Input() application: WorkflowData;

	selectedFormations: number[] = [];

	index: number = 0;
	@Input() countedItems: number[] = [];

	@Input() methodTypes: any[] = [];

	subscription: Subscription = new Subscription();

	blankFormation: FormationModel = {
		code: "",
		definition: "",
		isActive: true,
		isRequired: false,
		lastModifiedDateUTC: new Date
	}

	formations: FormationModel[]

	reviewStates: ApplicationState[] = [
		ApplicationState.VerifyCompletion,
		ApplicationState.InitialReview,
		ApplicationState.InitialApproval,
		ApplicationState.FinalApproval
	];


	get isInternal(): boolean {
		return this._auth.User.isInternal;
	}

	constructor(public _auth: AuthService, private domainService: DomainDefinitionService,) { super(_auth) }

	ngOnInit() {
		let obs$: Observable<FormationModel[]> = this.domainService.getFormations().pipe(
			tap((models: FormationModel[]) => {
				this.formations = models;
				this.formations.unshift(this.blankFormation);
			})

		);


		let subs$: Subscription = obs$.subscribe()
		this.subscription.add(subs$);

		if (this.application != null) {
			if (this.application.applicationState == (ApplicationState.InitialReview || ApplicationState.Approved)) {
				this.form.disable()
			}
		}


	}

	formationChanged(index: number, formationName: string): void {
		let formation = this.formations.find(f => f.code === formationName);
		if (formation != null) {
			let ctrl = this.form.get(`aapgCode${index}`);
			if (ctrl != null) {
				ctrl.setValue(formation.aapgCode);
			}
		}
	}

	getFieldName(name: string, index: number, prefixGroup: boolean): string {
		let value: string = `${name}${index}`;
		if (prefixGroup) {
			value = `formations|${value}`;
		}
		return `${name}${index}`;
	}


}
